var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgServe4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 67,
    viewBox: "0 0 72 67",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.5714 41.2308H46.2857V46.3846H38.5714V54.1154H33.4286V46.3846H25.7143V41.2308H33.4286V33.5H38.5714V41.2308ZM61.7143 20.6154H72V67H0V20.6154H10.2857V28.3462H20.5714V20.6154H51.4286V28.3462H61.7143V20.6154ZM48.8571 38.6538H41.1429V30.9231H30.8571V38.6538H23.1429V48.9615H30.8571V56.6923H41.1429V48.9615H48.8571V38.6538ZM54 15.4615V25.7692H59.1429V15.4615H54ZM12.8571 15.4615V25.7692H18V15.4615H12.8571ZM72 7.73077V18.0385H61.7143V12.8846H51.4286V18.0385H20.5714V12.8846H10.2857V18.0385H0V7.73077H25.7143V0H46.2857V7.73077H72ZM43.7143 2.57692H28.2857V7.73077H43.7143V2.57692Z",
    fill: "#5B21FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgServe4);
export default __webpack_public_path__ + "static/media/serve4.317756dc4f8e8a9f7a26c8b62e0f9cf6.svg";
export { ForwardRef as ReactComponent };